import { Injectable } from "@angular/core";

import { CoreState } from "../../state";

@Injectable({
	providedIn: "root",
})
export class CasinoBlockSelector {
	isCasinoBlocked() {
		return (state: CoreState): boolean | undefined => state.casinoBlock.isCasinoBlocked;
	}

	isPlayerProfileSelected() {
		return (state: CoreState): boolean | undefined => state.casinoBlock.isPlayerProfileSelected;
	}

	isSelectionPostponed() {
		return (state: CoreState): boolean | undefined => state.casinoBlock.isSelectionPostponed;
	}

	shouldChoosePlayerProfile() {
		return (state: CoreState): boolean =>
			state.casinoBlock.isPlayerProfileSelected === false && !state.casinoBlock.isSelectionPostponed;
	}
}
